import { Box, Typography } from "@mui/material";
import { PoweredByCircleLogo } from "../assets/Sidebar";

const VersionWrapper = () => (
  <Box>
    <Box
      sx={{
        mt: "auto",
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        gap: "8px",
      }}
    >
      <PoweredByCircleLogo />
      <Typography variant="body1" fontWeight={"medium"} color="gray">
        Powered by Mahalo
      </Typography>
    </Box>
    <Typography
      variant="body1"
      fontWeight={"medium"}
      color="gray"
      fontSize={12}
      sx={{ textAlign: "center" }}
    >
      Version 6.0.26 (29/07/2025)
    </Typography>
  </Box>
);

export default VersionWrapper;
